import { Component } from '@angular/core';
import { LanguageService } from '../../core/services/language.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  constructor(private languageService: LanguageService) {}

  openLinkedinWeb() {
		window.open('https://tw.linkedin.com/company/kunyoutech', '_blank');
	}

  /**
   * 當前語系是否為英文
   */
  isEnglish(): boolean {
    return this.languageService.getCurrentLang() === 'en-us';
  }
}
